import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FindDoctor = () => {
  const [city, setCity] = useState('');
  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState('');

  const fetchDoctorsByCity = async () => {
    try {
      const response = await axios.get(`http://localhost:5000/api/doctors?city=${city}`);
      setDoctors(response.data);
      setError('');
    } catch (error) {
      setError('No doctors found in this city');
      setDoctors([]);
    }
  };

  useEffect(() => {
    if (city) {
      fetchDoctorsByCity();
    }
  }, [city]);

  return (
    <div className="find-doctor-container">
      <h2>Find a Doctor</h2>
      <input
        type="text"
        placeholder="Enter City"
        value={city}
        onChange={(e) => setCity(e.target.value)}
      />
      <button onClick={fetchDoctorsByCity}>Search</button>

      {error && <div className="error-message">{error}</div>}

      <div className="doctors-list">
        {doctors.map((doctor) => (
          <div key={doctor._id} className="doctor-card">
            <h3>{doctor.name}</h3>
            <p>Specialization: {doctor.specialization}</p>
            <p>Experience: {doctor.experience} years</p>
            <p>Address: {doctor.address}</p>
            <p>Phone: {doctor.phone}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FindDoctor;